<template>
  <!-- <span class="font-family-body">Operai</span>
    <v-divider></v-divider> -->

  <div class="text-center w-100">
    <v-alert
    v-if="!CanGoFarward()"
      color="red darken-4"
      dark
      icon="mdi-alert-octagon-outline"
      dense
    >
      Alcune risorse selezionate non sono disponibili, rimuoverle dall'evento prima di procedere
    </v-alert> 
    <v-chip
      class="ma-1"
      v-bind:color="!isDisabled(select) ? 'blue' : 'red'"
      v-for="select in selectedResources"
      :key="select.descrizione"
      :v-model="select"
      :label="true"
      value="descrizione"
      outlined
      @click="uncheck(select)"
    >
      {{ select.descrizione }}
    </v-chip>

    <v-data-table
      v-model="selectedResources"
      :headers="headers"
      :items="resources"
      item-key="descrizione"
      show-select
      dense
      :search="search"
       :sort-by="['descrizione']"
      class="elevation-1"
    >
    <template v-slot:top>
      <v-toolbar flat> 
        <v-text-field
          v-model="search"
          class="mx-5"
          append-icon="mdi-magnify"
          label="Cerca..."
          single-line
          hide-details
        ></v-text-field>
      </v-toolbar>
    </template>
      <template #header.data-table-select></template>
      <template #item.data-table-select="{ item, isSelected }">
        <v-row align="center">
          <v-checkbox
            key="item.idRisorsa"
            style="height: 32px"
            v-bind:disabled="isDisabled(item)"
            v-model="isSelected"
            :error="isDisabled(item) && isSelected"
            :error-messages="
              item.event != null && isSelected
                ? 'risorsa non disponibile'
                : ''
            "
            :select="
              (s) => {
                alert(s.descrizione);
              }
            "
            v-on:change="chk_changed(isSelected, item)"
          >
          </v-checkbox>
        </v-row>
      </template>
      <template v-slot:item.event="{ item }">
        <div
          v-for="event in item.events"
          :key="event.idIntervento"
          class="text-center white--text font-weight-medium"
          v-bind:style="{
            'background-color': event.color ? event.color : '#777',
          }"
        >
          {{ event.descrizione }}
        </div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import moment from "moment";
import EasyPlanClient from "../../utils/EasyPlanClient";
export default {
  props: ["eventInfo", "events", "resourcesType","minItemSelected"],
  data() {
    return {
      selectedResources: [],
      select: true,
      search:"",
      headers: [
        { text: "Nominativo", value: "descrizione" },
        { text: "Disponibilità", value: "event" },
      ],
      resources: [],
      dayEvents:[]
    };
  },

  watch: {
    eventInfo: function (value, old) {
      if (value.idIntervento != old.idIntervento) this.selectedResources = [];
      console.debug("value");
      console.debug(value);
      console.debug("refresh");
      if (this.resources.length > 0 && value != null) {
        this.loadResourceEvents(this.resources, value);
      }
    },
    events: function (value, old) {
      if (this.resources.length > 0 && this.eventInfo != null) {
        this.loadResourceEvents(this.resources, this.eventInfo);
      }
    },
    selectedItems: function (value, old) {},
  },
  created() {
    switch (this.resourcesType) {
      case "Uomo":
        this.loadWorkers();
        break;
      case "Mezzo":
        this.loadVehicles();
        break;
      case "Attrezzatura":
        this.loadEquipment();
        break;
    }
  },
  methods: {
    CanGoFarward(){
        console.debug("checking if it can go farward 2",this.selectedResources)
      for(let i=0;i< this.selectedResources.length;i++)
      {
        var r=this.selectedResources[i];
        console.debug("checking if it is disabled",r)
        if(this.isDisabled(r)){

        console.debug("check r is disabled",r)
          return false
        }
      }
      if(this.minItemSelected!=undefined){
        if(this.selectedResources.length<this.minItemSelected)
          return false;
      }
      return true;
    },
    isDisabled(item) { 
      //canBeAdded
      let evInizio = Date.parse(this.eventInfo.inizio);
      let evFine = Date.parse(this.eventInfo.fine); 
      let collisionEvent = this.dayEvents.find((e) => {
        let fine = Date.parse(e.fine);
        let inizio = Date.parse(e.inizio);
        if (
          e.risorseIntervento.find((ri) => ri.idRisorsa == item.idRisorsa) !=
          undefined
        ) {
          //(I,F) (I),(F)
          if (inizio < evInizio && fine < evFine && fine > evInizio) {
            //iniziato dopo l'inizio e finito prima della fine MA la fine è maggiore dellinizio, (potrebbe essere semplicemente un evento precedente)
            console.debug("found1", e);
            return true;
          } else if (inizio > evInizio && fine < evFine) {
            //iniziato dopo l'inizio e finito prima della fine
            console.debug("found2", e);
            return true;
          } else if (inizio < evInizio && fine > evFine) {
            console.debug("found3", e);
            //Iniziato prima dell'inizio e finito dopo la fine
            return true;
          } else if (inizio > evInizio && fine > evFine && inizio < evFine) {
            console.debug("found4", e);
            //iniziato dopo l'inizio e finito dopo la fine MA inizio< evFine

            return true;
          } else if (e.giornoIntero|| this.eventInfo.giornoIntero) 
          { 
            return true;
            }
          else return false;
        } else return false;
      });
      return collisionEvent != undefined &&collisionEvent.idIntervento!=this.eventInfo.idIntervento;
    },
    GetSelectedResources(){
        return this.selectedResources;
    },
    chk_changed(v, e) {
      console.debug("v", v);
      console.debug("e", e);
      if (v) {
        if (
          this.selectedResources.find((w) => w.idRisorsa == e.idRisorsa) ==
            undefined
        ) {
          this.selectedResources.push(e);
          console.debug("added", e);
        }
      } else {
        this.selectedResources = this.selectedResources.filter(
          (w) => w.idRisorsa != e.idRisorsa
        );
      }
      this.eventInfo.risorse = this.eventInfo.risorse.filter(
        (r) => r.tipo != this.resourcesType
      );
      this.eventInfo.risorse.push(...this.selectedResources);

      // console.debug("selected", v);
      // console.debug("e", e);
    },

    loadResourceEvents(operators, eventInfo) {
      
      let evs = this.getEventsAtDate(eventInfo.inizio, eventInfo.fine, true);
      this.dayEvents=evs; 
      for (let wi = 0; wi < operators.length; wi++) {
        operators[wi].events = [];
      }
      for (let i = 0; i < evs.length; i++) {
        let ev = evs[i];
        if (ev.idIntervento != this.eventInfo.idIntervento) {
          for (let j in ev.risorseIntervento) {
            let res = ev.risorseIntervento[j];
            let w = operators.find((w) => w.idRisorsa == res.idRisorsa);
            if (w != undefined) {
              w.events.push(ev);
            }
          }
        }
      }
      this.resources = operators;

      if (Object.keys(this.eventInfo).length > 0 && this.eventInfo != undefined)
        this.selectedResources = this.resources.filter(
          (w) =>
            (eventInfo.risorse!=undefined?eventInfo.risorse:[]).find((r) => r.idRisorsa == w.idRisorsa) !=
              undefined 
        ); // this.eventInfo.risorse.filter((r) => r.tipo == "Uomo"&& r.event==null);
       
    },
    getEventsAtDate(inizio, fine, allDay) {
      console.debug("filtering evs");
      console.debug(this.events);
      inizio = moment(inizio).format("YYYYMMDD");
      fine = moment(fine).format("YYYYMMDD"); 

      let filtered = this.events.filter((e) => {
        let eIn = moment(e.inizio).format("YYYYMMDD");
        let eFi = moment(e.fine).format("YYYYMMDD"); 
        return eIn == inizio && eFi == fine;
      });
      console.debug("filtered=", filtered);
      return filtered;
    },
    uncheck: function (select) {
      this.selectedResources = this.selectedResources.filter(
        (descrizione) => descrizione !== select
      );
    },

    loadVehicles() {
      console.log("loading workers...");
      EasyPlanClient.Resources.GetAllVehicles(this.$route.params.companyAlias)
        .then((res) => {
          this.loadResourceEvents(res.data.data, this.eventInfo);
     
        })
        .catch((error) => {
          console.log(error);
          this.error = EasyPlanClient.GetErrorDescription(
            error.response.data.errorCode
          );
          console.error(
            "si è verificato un errore (" +
              error.response.data.errorCode +
              ")" +
              this.error
          );
          console.error(error);
        });
    },
    loadEquipment() {
      console.log("loading workers...");
      EasyPlanClient.Resources.GetAllEquipments(this.$route.params.companyAlias)
        .then((res) => {
          this.loadResourceEvents(res.data.data, this.eventInfo);
          
        })
        .catch((error) => {
          console.log(error);
          this.error = EasyPlanClient.GetErrorDescription(
            error.response.data.errorCode
          );
          console.error(
            "si è verificato un errore (" +
              error.response.data.errorCode +
              ")" +
              this.error
          );
          console.error(error);
        });
    },
    loadWorkers() {
      console.log("loading workers...");
      EasyPlanClient.Resources.GetAllOperators(this.$route.params.companyAlias)
        .then((res) => {
          this.loadResourceEvents(res.data.data, this.eventInfo);
         
        })
        .catch((error) => {
          console.log(error);
          this.error = EasyPlanClient.GetErrorDescription(
            error.response.data.errorCode
          );
          console.error(
            "si è verificato un errore (" +
              error.response.data.errorCode +
              ")" +
              this.error
          );
          console.error(error);
        });
    },
  },
};
</script>

<style>
.btnsContainer {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}

.v-input--selection-controls {
  margin-top: 0px !important;
}
/* .chipContainer {
  max-width: 560px;
} */
</style>
